import { Button, Group, Stack } from "@mantine/core";
import { IconBrandGoogle, IconBrandWindows } from "@tabler/icons-react";
import type { LoginTr } from "../../useLoginTranslations";
import styles from "../../LoginPage.module.css";

export interface SocialSignInButtonsProps {
  onGoogle: () => void;
  onMicrosoft: () => void;
  socialLoading: "google" | "microsoft" | null;
  tr: LoginTr;
  /** "stacked" = full-width primary-ish buttons, "row" = compact secondary buttons side by side. */
  layout?: "stacked" | "row";
}

export function SocialSignInButtons({
  onGoogle,
  onMicrosoft,
  socialLoading,
  tr,
  layout = "stacked",
}: SocialSignInButtonsProps) {
  const compact = layout === "row";

  const microsoftButton = (
    <Button
      variant="outline"
      size="md"
      className={styles.ssoButton}
      leftSection={<IconBrandWindows size={18} />}
      onClick={onMicrosoft}
      loading={socialLoading === "microsoft"}
      disabled={socialLoading !== null}
    >
      {compact
        ? tr("login.ssoShort.microsoft", "Microsoft")
        : tr("login.signInWithMicrosoft", "Sign in with Microsoft")}
    </Button>
  );

  const googleButton = (
    <Button
      variant="outline"
      size="md"
      className={styles.ssoButton}
      leftSection={<IconBrandGoogle size={18} />}
      onClick={onGoogle}
      loading={socialLoading === "google"}
      disabled={socialLoading !== null}
    >
      {compact ? tr("login.ssoShort.google", "Google") : tr("login.signInWithGoogle", "Sign in with Google")}
    </Button>
  );

  if (compact) {
    return (
      <Group grow gap="sm">
        {microsoftButton}
        {googleButton}
      </Group>
    );
  }

  return (
    <Stack gap="sm">
      {microsoftButton}
      {googleButton}
    </Stack>
  );
}
